import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/xr`;

export const XR = {
  worlds: () => axios.get(`${API}/worlds`).then((r) => r.data),
  world: (slug) => axios.get(`${API}/world/${slug}`).then((r) => r.data),
  guideChat: (message, session_id) =>
    axios.post(`${API}/guide/chat`, { message, session_id, world: "kurukshetra", character: "krishna" }).then((r) => r.data),
  submitAssessment: (answers, session_id) =>
    axios.post(`${API}/assessment/submit`, { answers, session_id }).then((r) => r.data),
  event: (event, data = {}, session_id, world = "kurukshetra") =>
    axios.post(`${API}/session/event`, { event, data, session_id, world }).then((r) => r.data).catch(() => null),
  partnerInterest: (payload) => axios.post(`${API}/partner-interest`, payload).then((r) => r.data),
};

// stable per-browser session id for analytics correlation
const LS = "edusphere_xr_session_v1";
export function xrSession() {
  let s = localStorage.getItem(LS);
  if (!s) {
    s = `xr_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
    localStorage.setItem(LS, s);
  }
  return s;
}
